import axios from 'axios'

const baseURL = process.env.VUE_APP_API_URL || "https://quicksend.asia/" 

const _axios = axios.create({
  baseURL
});


_axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  return Promise.reject(error.response)
});

export default _axios;
